module.exports = __webpack_public_path__ + "img/16.467db7c0.png";